import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { routesList } from './index';

const childRoutes = (routes) => {
  return routes.map(({ children, path, component: Component }, index) =>
    children ? (
      // Route item with children
      children.map(({ path, component: Component }, index) => (
        <Route
          key={index}
          path={path}
          exact
          render={props => (
            <Component {...props} />
          )}
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        exact
        render={props => (
          <Component {...props} />
        )}
      />
    )
  );
}

const Routes = () => {
  return (
    <Router>
      <Switch>
        {childRoutes(routesList)}
      </Switch>
    </Router>
  )
};

export default Routes;
